import { appendScriptSrc } from 'utils/scripts';
import { loadedScriptsOnScroll, recaptchSrc } from 'define/scripts';
require('assets/scss/app.scss');
require('lazysizes');
require('lazysizes/plugins/attrchange/ls.attrchange');
require('./static/entry-points');
require('./static/gclid');

const appendScriptsOnScroll = () => {
  const captchaLoaded = document.getElementById('recaptcha');

  if (!captchaLoaded) {
    appendScriptSrc(recaptchSrc, 'body', 'recaptcha');
  }

  sessionStorage.setItem(loadedScriptsOnScroll, 'true');
};

export const onInitialClientRender = () => {
  window.addEventListener('scroll', appendScriptsOnScroll, { once: true });
};
